export const REGEX_PATTERNS = {
  alphaSpace: /^[\sa-zA-Z]+$/,
  numbers: /^[0-9]+$/,
  email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  securePassword: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+{}":;'<>?,.\\/]).{8,}$/,
  dniNie: /\b(\d{8}[A-Za-z]|[XYZ]\d{7}[A-Za-z])\b/,
} as const;

export const REGEX_CELLPHONE_PATTERNS: { [country: string]: RegExp } = {
  '54': /^(?:(?:00)?549?)?0?(?:11|[2368]\d)(?:(?=\d{0,2}15)\d{2})??\d{8}$/,
  '57': /^(3[0-9]|[0-9])[0-9]{8}$/,
  '34': /^(?:11|[1-9])[0-9]{8}$/,
};
